(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bba-card-variants"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bba-card-variants')) {
    customElements.define('bba-card-variants', class BbaCardVariants extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.prepareHover();
        this.addEventListener('change', (event) => {
          const option = event.target.closest('input[type="radio"]');
          if (!option) return;
          const form = this.querySelector('form');
          const variantInput = form?.querySelector('[name="id"]');
          const button = form?.querySelector('[type="submit"]');
          if (variantInput) variantInput.value = option.value;
          this.updateImage(option);
          const card = this.closest('.card');
          for (const link of card?.querySelectorAll('a[href]') || []) {
            const url = new URL(link.href, location.origin);
            if (url.pathname === this.dataset.productUrl) { url.searchParams.set('variant', option.value); link.href = url.href; }
          }
          this.querySelector('[data-bba-variant-title]').textContent = option.dataset.title;
          this.querySelector('[data-bba-variant-price]').textContent = option.dataset.price;
          const comparePrice = this.querySelector('[data-bba-variant-compare-price]');
          comparePrice.textContent = option.dataset.comparePrice || '';
          comparePrice.hidden = !option.dataset.comparePrice;
          if (button) {
            button.disabled = option.dataset.available !== 'true';
            button.querySelector('[data-bba-add-label]').textContent = button.disabled ? 'Sold out' : 'Add to cart';
          }
        });
      }
      prepareHover() {
        const media = this.closest('.card')?.querySelector('.card__media .media');
        const primary = media?.querySelector('img');
        const secondary = media?.querySelector('img + img');
        if (!primary) return;
        primary.style.setProperty('opacity', '1', 'important');
        primary.style.zIndex = '0';
        if (!secondary) return;
        let hovered = false, readyToShow = false;
        const paint = () => {
          primary.style.setProperty('opacity', '1', 'important');
          secondary.style.setProperty('opacity', hovered && readyToShow ? '1' : '0', 'important');
        };
        secondary.style.zIndex = '1';
        secondary.style.transition = 'none';
        paint();
        media.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch') return;
          hovered = true; paint();
        });
        media.addEventListener('pointerleave', () => { hovered = false; paint(); });
        secondary.loading = 'eager';
        const ready = async () => {
          if (!secondary.naturalWidth) return;
          try { if (secondary.decode) await secondary.decode(); } catch { return; }
          if (!this.isConnected || !secondary.naturalWidth) return;
          readyToShow = true; paint();
        };
        secondary.addEventListener('load', ready);
        secondary.addEventListener('error', () => { readyToShow = false; paint(); });
        if (secondary.complete) ready();
      }
      updateImage(option) {
        const revision = this.imageRevision = (this.imageRevision || 0) + 1;
        const card = this.closest('.card');
        const image = card?.querySelector('.card__media .media > img');
        if (!image || !option.dataset.imageSrc) return;
        const next = new Image();
        next.sizes = image.sizes;
        next.srcset = option.dataset.imageSrcset || '';
        next.src = option.dataset.imageSrc;
        const commit = () => {
          if (revision !== this.imageRevision || !this.isConnected) return;
          image.srcset = next.srcset;
          image.src = next.src;
          image.alt = option.dataset.imageAlt || this.dataset.productTitle;
          image.width = Number(option.dataset.imageWidth) || image.width;
          image.height = Number(option.dataset.imageHeight) || image.height;
        };
        next.onload = () => { if (next.decode) next.decode().then(commit).catch(commit); else commit(); };
        next.onerror = () => {};
        if (next.complete && next.naturalWidth) next.onload();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bba-image-badges"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bba-image-badges')){
customElements.define('bba-image-badges',class extends HTMLElement{
connectedCallback(){
 if(this.ready)return;this.ready=true;
 try{this.variants=JSON.parse(this.querySelector('script').textContent);}catch(e){this.variants=[];}
 this.onChange=e=>{const variant=this.variants.find(v=>String(v.id)===String(e.target.value));if(variant)this.update(variant);};
 document.addEventListener('change',this.onChange);
 if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{if(data?.variant&&this.variants.some(v=>v.id===data.variant.id))this.update(data.variant);});
}
update(v){const badge=this.querySelector('.bba-image-badges__discount');const pct=v.compare_at_price>v.price?Math.floor((v.compare_at_price-v.price)*100/v.compare_at_price):0;badge.hidden=pct<=0;badge.textContent='−'+pct+'%';}
disconnectedCallback(){document.removeEventListener('change',this.onChange);this.unsubscribe?.();this.ready=false;}
});
}
  } catch(e) { console.error(e); }
})();

})();
